var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearAllFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 13L19 19M19 13L13 19M8 19V12.6627C8 12.4182 8 12.2959 7.97237 12.1808C7.94787 12.0787 7.90747 11.9812 7.85264 11.8917C7.7908 11.7908 7.70432 11.7043 7.53137 11.5314L1.46863 5.46863C1.29568 5.29568 1.2092 5.2092 1.14736 5.10828C1.09253 5.01881 1.05213 4.92127 1.02763 4.81923C1 4.70414 1 4.58185 1 4.33726V2.6C1 2.03995 1 1.75992 1.10899 1.54601C1.20487 1.35785 1.35785 1.20487 1.54601 1.10899C1.75992 1 2.03995 1 2.6 1H17.4C17.9601 1 18.2401 1 18.454 1.10899C18.6422 1.20487 18.7951 1.35785 18.891 1.54601C19 1.75992 19 2.03995 19 2.6V4.33726C19 4.58185 19 4.70414 18.9724 4.81923C18.9479 4.92127 18.9075 5.01881 18.8526 5.10828C18.7908 5.2092 18.7043 5.29568 18.5314 5.46863L15 9",
    stroke: "#FF0000",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAllFilter);
export default __webpack_public_path__ + "static/media/clearAllFilter.7cc6e20dc35469e1b7d285db2dd4aa72.svg";
export { ForwardRef as ReactComponent };